/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable camelcase */
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPencilAlt,
} from '@fortawesome/free-solid-svg-icons';
import './TrustedServices.css';
import {
  sess_put,
} from '../../../utils/HttpRequests';

const EditProrityInTrustedService = (props) => {
  const [show, setShowModal] = useState(false);
  const { trustedServices, getAllTrustedServices } = props;
  const [services, setServices] = useState(trustedServices);
  const [error, setError] = useState('');

  const editPriorityModalHTML = trustedServices.map((service, id) => (
    <>
      <tr style={{ height: '4em' }}>
        <td>
          <img src={service.icon_url} alt={service.name} style={{ width: '25px', height: '25px' }} />
        </td>
        <td>
          {service.name}
        </td>
        <td>
          <input
            className="form-control service-input"
            name="name"
            type="number"
            value={service.priority}
            onChange={(e) => {
              const tempServices = [...trustedServices];
              tempServices[id].priority = e.target.value;
              setServices(tempServices);
            }}
          />
        </td>
      </tr>
    </>
  ));

  const isValidPriorities = () => {
    let priorities = trustedServices.map((s) => s.priority * 1).filter(Boolean);
    priorities = [...new Set(priorities)];
    if (priorities.length !== services.length) {
      return false;
    }
    return true;
  };

  return (
    <>
      <FontAwesomeIcon
        icon={faPencilAlt}
        onClick={(e) => {
          e.preventDefault();
          setShowModal(true);
          // showModalAndAssignSenderId(sender._id);
        }}
      />
      <Modal
        show={show}
        onHide={() => { setShowModal(false); }}
        dialogClassName="edit-priority-modal"
      >

        <Modal.Title>Update Priorities</Modal.Title>
        <Modal.Body>
          <div className="trusted-service-table">
            <table>
              <thead>
                <tr>
                  <th />
                  <th scope="col">
                    <center>
                      <a>
                        Name
                      </a>
                    </center>
                  </th>
                  <th scope="col">
                    <center>
                      Priority
                    </center>
                  </th>

                </tr>
              </thead>
              <tbody>

                {editPriorityModalHTML}
                {/* {error && <div>{error}</div>} */}
              </tbody>

            </table>
            {error && <div style={{ color: 'red' }}>{error}</div>}
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={async () => {
              try {
                if (isValidPriorities()) {
                  setError('');
                  const sessionToken = localStorage.getItem('admin-panel-sessionToken');
                  await sess_put('admin/console/update-priorities', sessionToken, { services: trustedServices });
                  setShowModal(false);
                  getAllTrustedServices();
                } else {
                  setError('Invalid priorities');
                }
              } catch (err) {
                setError(err.message || 'somwthing went wrong| updatePriorities');
              }
            }}
          >
            Update
          </Button>
          <Button variant="primary" onClick={() => { setShowModal(false); setError(''); setServices(''); }}>
            Cancel
          </Button>

        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditProrityInTrustedService;
